// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__5EC4j","rotate":"Loader_rotate__dqZ3L","particle":"Loader_particle__ThRZU","orbit":"Loader_orbit__2F9zP"};